const CONSTANT = {
  // baseUrl: ""
  baseUrl: process.env.API_URL,
  // baseUrl: "http://localhost:9666"
  // baseUrl: "http://mockurl.org"
}

export default CONSTANT
